var ValidationCollector = /** @class */ (function () {
    function ValidationCollector(errorModel) {
        var _this = this;
        var _a;
        this._index = 0;
        this._validations = [];
        (_a = errorModel === null || errorModel === void 0 ? void 0 : errorModel.errors) === null || _a === void 0 ? void 0 : _a.forEach(function (x) { return _this.addError(x); });
    }
    ValidationCollector.prototype.addError = function (value) {
        this.addValidation(value, false);
        return this;
    };
    ValidationCollector.prototype.addWarning = function (value) {
        this.addValidation(value, true);
        return this;
    };
    ValidationCollector.prototype.clear = function () {
        this._validations = [];
    };
    ValidationCollector.prototype.any = function () {
        return this._validations.length > 0;
    };
    Object.defineProperty(ValidationCollector.prototype, "validations", {
        get: function () {
            return this._validations;
        },
        enumerable: true,
        configurable: true
    });
    ValidationCollector.prototype.addValidation = function (value, isWarning) {
        var validation = new Validation(this._index++, value, isWarning);
        this._validations.push(validation);
    };
    return ValidationCollector;
}());
export { ValidationCollector };
var Validation = /** @class */ (function () {
    function Validation(index, value, isWarning) {
        this._index = index;
        this._value = value;
        this._isWarning = isWarning;
    }
    Object.defineProperty(Validation.prototype, "index", {
        get: function () {
            return this._index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Validation.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Validation.prototype, "isWarning", {
        get: function () {
            return this._isWarning;
        },
        enumerable: true,
        configurable: true
    });
    return Validation;
}());
